import React from "react";

export const specialSurveyDateBodyTemplate = (rowData: any) => {
    const vesselSpecialSurveyDate = rowData.vessel.specialSurveyDate;

    if (!vesselSpecialSurveyDate) {
        return <React.Fragment></React.Fragment>;
    }

    const inThePast = new Date() > vesselSpecialSurveyDate;

    const renderDate = (vesselSpecialSurveyDate: any) =>
        typeof vesselSpecialSurveyDate === "string"
            ? new Date(vesselSpecialSurveyDate).toLocaleDateString("en-GB")
            : vesselSpecialSurveyDate.toLocaleDateString("en-GB");

    return (
        <div className={inThePast ? "text-danger" : ""}>
            <p>{renderDate(vesselSpecialSurveyDate)}</p>
        </div>
    );
};
